import type { IOthersDTO, IRawOther } from "~/features/Dispatch/interfaces/IDispatchRegistrationOthers";

export function toDomain(other: IRawOther): IOthersDTO {
  return {
    id: other.id,
    item: other.item,
    notes: other.notes,
    occurrenceId: other.occurrence_id,
    createdAt: other.created_at,
    updatedAt: other.updated_at,
    deletedAt: other.deleted_at
  }
}

export function toFetch(other: IOthersDTO) {
  return {
    id: other.id,
    item: other.item,
    notes: other.notes,
    occurrence_id: other.occurrenceId
  }
}